// extracted by mini-css-extract-plugin
export default {"default-input":"styles_default-input__+2WAn","borderless-input":"styles_borderless-input__WtULy","input":"styles_input__K-IkZ","disabled":"styles_disabled__2IZ5h"};